export const SET_INTAKE_FORM_VALUES = 'setIntakeFormValues';
export const SET_FIELD_DEFINITIONS = 'setFieldDefinitions';
export const SET_FIELD_DEPENDENCY_MAP = 'setFieldDependencyMap';
export const SET_POA_GEM_CONFIG = 'setPoaGemConfig';
